import React from 'react'
import { Maybe } from '@Types'
import { INumTitles } from '@App/helpers/pagination/get-num-titles'
import CustomToolTip from '../../Tooltips/CustomToolTip'
import { TOOLTIP_TEXT } from '@Const/tooltip-text'
import './index.scss'
import { PAGINATION } from '@Const/pagination'
import CompactViewToggle from '@Components/WorkItemV2/CompactViewToggle'

interface PaginationResultsBlockProps {
    workNumTitles: Maybe<INumTitles>
    totalResults: number
    justResults?: boolean
    hideNoResults?: boolean // TODO: No Results Message Shouldn't Live In The Pagination Header
    resultsMessage?: string
    showCompactToggle?: boolean
}
const PaginationResultsBlock = (props: PaginationResultsBlockProps) => {
    const { workNumTitles, totalResults, justResults, hideNoResults, showCompactToggle } = props

    const resultsMessage = props.resultsMessage ? props.resultsMessage : 'results'

    return (
        <section className="table-head">
            <span className="results-with-tooltip">
                {workNumTitles && totalResults > 0 ? (
                    <>
                        <p className="small bold">
                            {!justResults ? (
                                <>
                                    Showing {workNumTitles.firstTitle.toLocaleString()} -{' '}
                                    {workNumTitles.lastTitle.toLocaleString()} of{' '}
                                </>
                            ) : (
                                <>Showing </>
                            )}
                            {totalResults > PAGINATION.paginationLimit ? (
                                <>
                                    {PAGINATION.paginationLimit.toLocaleString()} accessible {resultsMessage} (Total{' '}
                                    {totalResults.toLocaleString()})
                                </>
                            ) : (
                                <>
                                    {totalResults.toLocaleString()} {resultsMessage}{' '}
                                </>
                            )}
                        </p>
                        {totalResults > PAGINATION.paginationLimit && (
                            <CustomToolTip type="?" info={TOOLTIP_TEXT.pagination.totalResults} />
                        )}
                    </>
                ) : (
                    !hideNoResults && <p className="small bold">No results found</p>
                )}
            </span>
            {showCompactToggle && <CompactViewToggle />}
        </section>
    )
}

export default PaginationResultsBlock
